import { AlertTriangleIcon } from 'lucide-react'
import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** One-line red warning (triangle + message) shown above a blocked submit/action button. */
export function InlineError({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p className={cn('text-chart-red flex items-center gap-1.5 text-xs tracking-tight', className)}>
      <AlertTriangleIcon size={13} className="shrink-0" />
      <span>{children}</span>
    </p>
  )
}
